import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-logs-sessions',
    templateUrl: './user-logs-sessions.component.html',
    styleUrls: ['./user-logs-sessions.component.scss'],
    standalone: false
})
export class UserLogsSessionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
